var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfigPage',[_c('ConfigItem',{attrs:{"title":_vm.__('Tamanho máximo', 'settings'),"description":_vm.__(
        'Qualquer arquivo com tamanho maior do definido nessa tela será bloqueado',
        'settings'
      )}},[_c('FileSizeForm',{ref:"uploadLimit",attrs:{"title":_vm.__('Limite de upload gestão documental', 'settings'),"loading":_vm.loading},on:{"reset":_vm.getData,"submit":_vm.submit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }